import React, { useState } from "react";
import { MOAT_TYPES, MOAT_MOMENTS } from "./data.js";

export default function ScoutStage({ onComplete }) {
  const [index, setIndex] = useState(0);
  const [correctCount, setCorrectCount] = useState(0);
  const [picked, setPicked] = useState(null);

  const current = MOAT_MOMENTS[index];
  const done = index >= MOAT_MOMENTS.length;

  const choose = (typeId) => {
    if (picked) return;
    const correct = typeId === current.correct;
    if (correct) setCorrectCount((c) => c + 1);
    setPicked(typeId);
  };

  const advance = () => {
    setPicked(null);
    setIndex((i) => i + 1);
  };

  if (done) {
    return (
      <div className="animate-popIn text-center">
        <p className="label-pixel mb-2 text-cyan">Pitch Floor Complete</p>
        <h2 className="pixel-heading mb-4 text-base text-mist">Five Moats, Spotted</h2>

        <div className="mx-auto mb-6 max-w-sm space-y-2 border-2 border-black bg-ink p-4 text-left text-sm">
          <div className="flex justify-between">
            <span className="text-mist/60">Moats Correctly Read</span>
            <span className="text-cyan">
              {correctCount}/{MOAT_MOMENTS.length}
            </span>
          </div>
        </div>

        <p className="mx-auto mb-6 max-w-sm text-xs text-mist/60">
          Regulatory Moat, Recurring Contract, Paid Twice, Hard Door, Invisible Edge — same five
          patterns, over and over. Most people never learn to spot them because the businesses
          wearing them are too unglamorous to look twice at.
        </p>

        <button onClick={() => onComplete({ correctCount })} className="btn-magenta">
          CHECK THE AI LAYERS ▶
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4 flex items-center justify-between font-display text-[9px] text-mist/60">
        <span>THE PITCH FLOOR</span>
        <span>
          {index}/{MOAT_MOMENTS.length}
        </span>
      </div>

      <p className="mb-5 text-xs text-mist/60">
        Read the pitch. Which moat is actually protecting this business?
      </p>

      <div
        key={current.id}
        className={`mb-5 border-2 bg-ink p-6 text-center transition-colors ${
          picked ? (picked === current.correct ? "border-lime shadow-glow-cyan" : "border-danger") : "border-black"
        }`}
      >
        <p className="text-sm leading-relaxed text-mist/80">{current.text}</p>
      </div>

      {!picked ? (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {MOAT_TYPES.map((type) => (
            <button
              key={type.id}
              onClick={() => choose(type.id)}
              className="flex flex-col items-center gap-1 border-2 border-mist/30 px-3 py-4 font-display text-[8px] uppercase text-mist transition-colors hover:border-cyan hover:text-cyan"
            >
              <span className="text-lg">{type.icon}</span>
              {type.label}
            </button>
          ))}
        </div>
      ) : (
        <div
          className={`animate-popIn border-2 p-4 text-center ${
            picked === current.correct ? "border-lime bg-lime/10 text-lime" : "border-danger bg-danger/10 text-danger"
          }`}
        >
          <p className="mb-1 font-display text-[9px] uppercase">
            {picked === current.correct
              ? "Moat Spotted"
              : `Not Quite — It Was ${MOAT_TYPES.find((t) => t.id === current.correct)?.label}`}
          </p>
          <p className="mb-3 text-xs text-mist/80">{current.explain}</p>
          <button onClick={advance} className="btn-cyan !text-[9px]">
            CONTINUE ▶
          </button>
        </div>
      )}
    </div>
  );
}
